<template>
  <div>
    <vuetable ref="vuetable" :api-url="url" :httpOptions="options" :fields="fields" ></vuetable>
  </div>
</template>


<script>
import Vuetable from 'vuetable-2/src/components/Vuetable';
import url from '../utils/url';
import moment from 'moment';

export default {
  props: ['url'],
  components: {
    Vuetable
  },
  data() {
    return {
      options: {
        headers: { Authorization: window.localStorage.getItem('biyadmin') }
      },
      fields: [
        {
          name: '__sequence', // <----
          title: '#'
        },
        {
          name: 'serviceType',
          title: 'Service',
          callback: 'upperCase'
        },
        {
          name: 'status',
          title: 'Status',
          callback: 'statusLabel'
        },
        {
          name: 'updatedAt',
          title: 'Last Check',
          callback: 'formatDate|DD/MMM HH:mm'
        }
      ]
    };
  },
  methods: {
    formatDate(value, fmt = 'D MMM YYYY') {
      return value == null ? '' : moment(value).fromNow();
    },
    statusLabel(value) {
      if(value) { return  `<span class="tag is-success">online</span>` }
      return  `<span class="tag is-danger">offline</span>`;
    },
    upperCase(value) {
      return value.toUpperCase();
    }
  }
};
</script>


// WEBPACK FOOTER //
// StatusTable.vue?1aee81e0